/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as moment from 'moment';

// Make Monday the first day of the week for all moment-based date adapters
// (tasks, daily-resume timeline pickers, etc.). Sprint Form uses NativeDateAdapter
// and handles this via MondayNativeDateAdapter.
moment.updateLocale('en', { week: { dow: 1, doy: 4 } });

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
